export class PaymentTerm {
    ID?: number;
    Code?: string;
    Name?: string;
    Inactive: boolean;
}

export default PaymentTerm;